import styled from "styled-components";
import { Button } from "react-bootstrap";

export const AppButton = styled(Button)`
  color: #ad0044;
  background-color: transparent;
  font-family: Armata-Regular;
  letter-spacing: 1px;
  font-size: 16px;
  width: 300px;
  padding: 10px 0px;
  border-radius: 20px;
  border: 1px solid #ad0044;
  &:hover {
    outline: none;
    box-shadow: 0 0 3pt 2pt #ad0044;
    color: #ffffff;
    background-color: #ad0044;
    border-color: #ad0044 !important;
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 3pt 2pt #ad0044;
    color: #ffffff;
    background-color: #ad0044;
    border-color: #ad0044 !important;
  }
`;
